import * as GroupType from 'constants/GroupType';

const BADMINTON_GROUP_MAP = {};

BADMINTON_GROUP_MAP[0] = GroupType.DEFAULT_GROUP;
BADMINTON_GROUP_MAP[1] = GroupType.FIRST_PERIOD_GROUP;
BADMINTON_GROUP_MAP[2] = GroupType.SECOND_PERIOD_GROUP;
BADMINTON_GROUP_MAP[3] = GroupType.THIRD_PERIOD_GROUP;
BADMINTON_GROUP_MAP[4] = GroupType.FIRST_PERIOD_TEN_POINTS_MINI_MATCH_GROUP;
BADMINTON_GROUP_MAP[5] = GroupType.FIRST_PERIOD_FIFTEEN_POINTS_MINI_MATCH_GROUP;
BADMINTON_GROUP_MAP[6] = GroupType.SECOND_PERIOD_TEN_POINTS_MINI_MATCH_GROUP;
BADMINTON_GROUP_MAP[7] = GroupType.SECOND_PERIOD_FIFTEEN_POINTS_MINI_MATCH_GROUP;
BADMINTON_GROUP_MAP[8] = GroupType.THIRD_PERIOD_TEN_POINTS_MINI_MATCH_GROUP;
BADMINTON_GROUP_MAP[9] = GroupType.THIRD_PERIOD_FIFTEEN_POINTS_MINI_MATCH_GROUP;

export default BADMINTON_GROUP_MAP;


// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/sportGlossary/Badminton/GroupMap.js